// extracted by mini-css-extract-plugin
export var buttonContent = "_3m-0";
export var centered = "_3m-1";
export var centeredFlex = "_3m-2";
export var errorText = "_3m-3";
export var icon = "_3m-4";
export var iconButtonContent = "_3m-5";
export var monospace = "_3m-6";
export var padded = "_3m-7";